"use strict";

var Table = Table || {};
jQuery.noConflict();

(function ($) {
  'use strict';

  Table.TableView = Backbone.View.extend({
    el: 'body',
    interval: null,
    tableName: null,
    events: {
      'change form[name="table_filters"].auto-refresh select': 'autoRefresh',
      'change form[name="table_filters"].auto-refresh input.form-control': 'autoRefresh',
      'change select[name="max-per-page"]': 'maxPage',
      'submit form[name="table_filters"]': 'submit',
      'click .auto-reload': 'toggleAutoReload'
    },
    initialize: function initialize() {
      this.tableName = this.$el.find('.table-data').attr('id');

      if (_.isUndefined(Cookies.getJSON(this.tableName))) {
        Cookies.set(this.tableName, {});
      }

      this.$el.find('input.dateInput').datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: 'yy-mm-dd'
      });
      this.autoReload();
    },
    maxPage: function maxPage(e) {
      var tableCookie = Cookies.getJSON(this.tableName);
      tableCookie.maxPerPage = $(e.currentTarget).val();
      Cookies.set(this.tableName, tableCookie);

      _APP.utilities.showLoader();

      window.location.href = window.location.href.replace('#', '');
    },
    autoRefresh: function autoRefresh() {
      _APP.utilities.showLoader();

      $('form[name="table_filters"].auto-refresh').submit();
    },
    submit: function submit() {
      $('form[name="table_filters"] select').each(function (index, obj) {
        if ($(obj).val() === "") {
          $(obj).remove();
        }
      });
    },
    toggleAutoReload: function toggleAutoReload(e) {
      e.preventDefault();
      var tableCookie = Cookies.getJSON(this.tableName);
      tableCookie.reload = tableCookie.reload ? 0 : 1;
      Cookies.set(this.tableName, tableCookie);

      if (tableCookie.reload) {
        var s = window.location.href;
        window.location.href = s.substring(0, s.indexOf('#') !== -1 ? s.indexOf('#') : s.length);
      }

      this.autoReload();
    },
    autoReload: function autoReload() {
      var tableCookie = Cookies.getJSON(this.tableName);

      if (tableCookie.reload) {
        this.$el.find('.auto-reload i').addClass('text-success');
        this.interval = setInterval(function () {
          var s = window.location.href;
          window.location.href = s.substring(0, s.indexOf('#') !== -1 ? s.indexOf('#') : s.length);
        }, 30 * 1000);
      } else {
        this.$el.find('.auto-reload i').removeClass('text-success');
        clearInterval(this.interval);
      }
    }
  });
  $(document).ready(function () {
    Table.tableView = new Table.TableView();
  });
})(jQuery);